/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Otto_Hahn_Schule_Frankfurt4Inputs */

const en__field_enum_otto_hahn_schule_frankfurt4 = /** @type {(inputs: _Field_Enum_Otto_Hahn_Schule_Frankfurt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frankfurt`)
};

const de__field_enum_otto_hahn_schule_frankfurt4 = /** @type {(inputs: _Field_Enum_Otto_Hahn_Schule_Frankfurt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otto-Hahn-Schule`)
};

/**
* | output |
* | --- |
* | "Frankfurt" |
*
* @param {_Field_Enum_Otto_Hahn_Schule_Frankfurt4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_otto_hahn_schule_frankfurt4 = /** @type {((inputs?: _Field_Enum_Otto_Hahn_Schule_Frankfurt4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Otto_Hahn_Schule_Frankfurt4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_otto_hahn_schule_frankfurt4(inputs)
	return de__field_enum_otto_hahn_schule_frankfurt4(inputs)
});
export { _field_enum_otto_hahn_schule_frankfurt4 as "_field_enum_Otto_Hahn_Schule_Frankfurt" }